var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"order-label-print"}},_vm._l((_vm.selected),function(product){return _c('div',{key:product.index,staticClass:"mt-5"},[_c('svg',{staticClass:"barcode",attrs:{"jsbarcode-displayvalue":"true","jsbarcode-format":"code128","jsbarcode-value":product.sku,"jsbarcode-height":"92","jsbarcode-width":"2"}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }